import React, { useCallback, useState } from "react";

import { EditIcon } from "icons";

import IconButton from "components/IconButton";

import { ECompanySettingsFeatureType } from "entities/Company/components/CompanySettings/constants";
import { useCheckFeature } from "entities/Company/components/CompanySettings/utils";
import EditSectionDialog from "entities/MemoTemplate/components/EditSectionDialog";
import { EMemoSectionType } from "entities/MemoTemplate/constants";
import { IMemoTemplateSection } from "entities/MemoTemplate/sdk";

interface IEditSectionButton {
  section: IMemoTemplateSection;
  children?: React.ReactNode;
}

const EditSectionButton = React.forwardRef<
  HTMLButtonElement,
  IEditSectionButton
>(({ children, section, ...props }: IEditSectionButton, ref) => {
  const [open, setOpen] = useState(false);

  const onEditSectionDialogOpen = useCheckFeature({
    feature: ECompanySettingsFeatureType.ONBOARDING_COMPANY_PACKAGE,
    callback: () => setOpen(true),
  });

  const handleEditSectionClick = useCallback(() => {
    if (section.section_type === EMemoSectionType.AI_ANSWER) {
      onEditSectionDialogOpen();
    } else {
      setOpen(true);
    }
  }, [onEditSectionDialogOpen, section.section_type]);

  return (
    <>
      <IconButton
        {...props}
        ref={ref}
        sx={{ borderRadius: 0 }}
        onClick={handleEditSectionClick}
      >
        <EditIcon />
      </IconButton>
      <EditSectionDialog
        section={section}
        open={open}
        onClose={() => setOpen(false)}
        onSectionEditted={() => {
          setOpen(false);
        }}
      />
    </>
  );
});

export default EditSectionButton;
